<script setup lang="ts">
// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "flex" | "grid" | "transform" | "table";
  }>(),
  {
    type: "flex"
  }
);

const parentStyle: Record<string, string> = {
  display: "block",
  width: "100%",
  height: "100%",
  position: "relative"
};
const childStyle: Record<string, string> = {};

function setStyle() {
  switch (props.type) {
    case "table":
      parentStyle.display = "table";
      childStyle.display = "table-cell";
      childStyle.verticalAlign = "middle";
      childStyle.textAlign = "center";
      break;
    case "transform":
      childStyle.position = "absolute";
      childStyle.top = "50%";
      childStyle.left = "50%";
      childStyle.transform = "translate(-50%, -50%)";
      break;
    case "grid":
      parentStyle.display = "grid";
      parentStyle.justifyContent = "center";
      parentStyle.alignItems = "center";
      break;
    case "flex":
    default:
      parentStyle.display = "flex";
      parentStyle.justifyContent = "center";
      parentStyle.alignItems = "center";
  }
}
setStyle();

defineExpose({});
</script>

<template>
  <div
    class="layout-center"
    :style="parentStyle"
  >
    <div :style="childStyle">
      <slot></slot>
    </div>
  </div>
</template>
